export const releasesPlanAdmissionTableColumnClasses = {
  name: 'pf-m-width-20 wrap-column',
  application: 'pf-m-width-30',
  source: 'pf-m-width-20',
  blockReleases: 'pf-m-width-20',
  kebab: 'pf-c-table__action',
};

const ReleasePlanAdmissionListHeader = () => {
  return [
    {
      title: 'Name',
      props: { className: releasesPlanAdmissionTableColumnClasses.name },
    },
    {
      title: 'Application',
      props: { className: releasesPlanAdmissionTableColumnClasses.application },
    },
    {
      title: 'Source Namespace',
      props: { className: releasesPlanAdmissionTableColumnClasses.source },
    },
    {
      title: 'Block releases',
      props: { className: releasesPlanAdmissionTableColumnClasses.blockReleases },
    },
    {
      title: ' ',
      props: {
        className: releasesPlanAdmissionTableColumnClasses.kebab,
      },
    },
  ];
};

export default ReleasePlanAdmissionListHeader;
